import React from "react";
import styles from "./header-block.module.css";
import { cn } from "../lib/helpers";

const HeaderBlock = (props) => {
  const { text, color, alignment } = props;
  const colorStyle = color === "cyan" ? styles.colorCyan : styles.colorCream;
  const alignmentStyle =
    alignment === "left" ? styles.alignLeft : alignment === "right" ? styles.alignRight : styles.alignCenter;

  return (
    <div className={cn(styles.root, alignmentStyle)}>
      <h2 className={cn(styles.text, colorStyle)}>{text}</h2>
    </div>
  );
};

export default HeaderBlock;
